import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';

import { ViewItemService } from '../../product/product-view/services/view-item.service';

import { GA4ConfigurationEvents } from './configs/ga4-configuration-events.class';
import { GA4FormDirective } from './directives/ga4-form.directive';
import { GA4EventParserService } from './services/ga4-event-parser.service';
import { GA4AnalyticsEffects } from './store/ga4-analytics.effects';
import { GA4ProductOriginEffects } from './store/ga4-product-origin.effects';

import { ConfigurationService } from '@shared/analytics/COMMON/services/configuration.service';

@NgModule({
    declarations: [
        GA4FormDirective,
    ],
    imports: [
        CommonModule,
        EffectsModule.forFeature([GA4AnalyticsEffects, GA4ProductOriginEffects]),
    ],
    providers: [
        ConfigurationService,
        GA4ConfigurationEvents,
        GA4EventParserService,
        ViewItemService,
    ],
    exports: [
        GA4FormDirective,
    ],
})
export class GA4AnalyticsModule { }
